module.exports = __webpack_public_path__ + "static/media/Ticketing-Table-for-6.b162894c.svg";